<template>
    <div>
        <div class="page-header">
            <h1 class="page-title">{{$t('static_page.title')}}</h1>

            <div>
                <a href="#" class="btn btn--primary" @click.prevent="$router.push({name: 'static.create'})">
                    {{ $t('static_page.add') }}
                </a>
            </div>
        </div>

        <div class="filters">
            <div class="search">
                <img src="/svgs/search-icon.svg" alt="search-icon">
                <input class="search"
                       type="text"
                       :placeholder="$t('general.search') + '...'"
                       v-model="searchQuery"
                       @input="onSearchInput" />
            </div>
        </div>

        <table class="table" ref="overviewTable">
            <thead>
                <tr>
                    <th>{{ $t('static_page.url') }}</th>
                    <th>{{ $t('static_page.meta_title') }}</th>
                    <th>{{ $t('static_page.meta_description') }}</th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="item in items" :key="item.id" @click="showDetail(item)">
                    <td>{{ item.url }}</td>
                    <td>{{ item.meta_title }}</td>
                    <td>{{ item.meta_description }}</td>
                </tr>
            </tbody>
        </table>

        <div class="pagination pagination--push-top" v-if="totalPages > 1">
            <span @click="paginate(n)" v-for="n in paginationPages" :class="{'active' : n === page}">{{ n }}</span>
        </div>
    </div>
</template>

<script>
    import { RedirectService } from '../../services';
    import debounce from 'lodash/debounce';
    import StaticPageService from "../../services/static-page";

    export default {
        name: 'redirects',

        data() {
            return {
                items: [],
                searchQuery: '',
                page: 1,
                totalPages: 1,
            }
        },

        computed: {
            paginationPages() {
                const totalPages = this.totalPages;
                const page = this.page;
                const pages = 17;

                let lowerLimit = Math.min(page, totalPages);
                let upperLimit = Math.min(page, totalPages);

                for (let b = 1; b < pages && b < totalPages;) {
                    if (lowerLimit > 1) {
                        lowerLimit--;
                        b++;
                    }

                    if (b < pages && upperLimit < totalPages) {
                        upperLimit++;
                        b++;
                    }
                }

                if (lowerLimit === 0 || upperLimit === 0) {
                    return [];
                }

                return Array(upperLimit - lowerLimit + 1).fill().map((_, idx) => lowerLimit + idx);
            },
        },

        methods: {
            fetchData() {
                const params = {
                    page: this.page,
                    search: this.searchQuery,
                };

                const promise = StaticPageService.index(params);

                promise.then(response => {
                    this.page = response.data.current_page;
                    this.totalPages = response.data.last_page;
                    this.items = response.data.data;
                });

                return promise;
            },

            onSearchInput: debounce(function () {
                let promise = this.fetchData();
                promise.then(() => {
                    this.resetPagination();
                });
            }, 250),

            paginate(page) {
                this.page = page;
                this.fetchData().then(response => {
                    const table = this.$refs.overviewTable;
                    table.scrollIntoView({ behavior: 'smooth' });
                });
            },

            resetPagination() {
                this.page = 1;
            },

            showDetail(item) {
                this.$router.push('static/' + item.id)
            },
        },

        beforeMount() {
            this.fetchData();
        }
    }
</script>
